module.exports = __webpack_public_path__ + "img/10.493a50f6.png";